import React, {useEffect} from "react";
import MobileDetect from "mobile-detect";

export const MainScreen = () => {

    useEffect(() => {
        const md = new MobileDetect(window.navigator.userAgent);
        console.log("md.os():", md.os());
        if (md.is('iPhone')) {
            window.location.href = `${process.env.REACT_APP_IOS_APP_STORE_LINK}`;
        }
        else if (md.os() === "AndroidOS") {
            window.location.href = `${process.env.REACT_APP_ANDROID_APP_STORE_LINK}`;
        }
        else {
            window.location.href = `${process.env.REACT_APP_DEFAULT_LINK}`;
        }
    }, []);

    return (
        <div>Redirecting ...</div>
    );
}
